import React from 'react';
import { Player, Controls } from '@lottiefiles/react-lottie-player';

function MrphLottie({
  src,
  autoplay,
  loop,
  controlsVisible,
  buttons,
  ...props
}) {
  return (
    <Player autoplay={autoplay} loop={loop} src={src} {...props}>
      <Controls visible={controlsVisible} buttons={buttons} />
    </Player>
  );
}

export { MrphLottie as Lottie };
